module.exports = __webpack_public_path__ + "static/late.d8e341d2.svg";